import React from 'react';

export const SectionHeader: React.FC<any> = ({ sectionNumber, headingText, canEdit, editButton }) => {
    const sectionContainerStyle: React.CSSProperties = {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: '#EFF0F0',
        height: '60px',
        borderTop: '1px solid #878A8C',
        borderBottom: '1px solid #D0D3D3'
    };

    const sectionHeaderStyle: React.CSSProperties = {
        lineHeight: '60px',
        paddingRight: '16px',
        paddingLeft: '18px',
        fontFamily: `"Ensign:Sans", Arial,"noto sans" ,sans-serif`,
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '20px',
        color: '#000000'
    };
    return (
        <div style={sectionContainerStyle}>
            <div style={sectionHeaderStyle}>{`${sectionNumber}. ${headingText}`}</div>
            <div style={{ marginRight: '15px', display: 'flex' }}>{canEdit && editButton}</div>
        </div>
    );
};
